import React from "react";
import Buttons from "react-multi-date-picker/components/button";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { contvertHTMLToPlain } from "../../../../utils/constants";

export default function DeleteQuestionModal({
  open,
  onClose,
  question,
  onDelete,
}) {
  return (
    <Modal isOpen={open}>
      <ModalHeader toggle={onClose} className="trivia_modal_header_bg deleteQ">
        Delete question
      </ModalHeader>
      {
          question && question._id ?   <ModalBody className="p-5">
          <h5>Are you sure you want to delete this question?</h5>
          <br />
          <p>"{contvertHTMLToPlain(question.questionText)}"</p>
        </ModalBody>:""
      }
    

      <ModalFooter>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          color="success"
          onClick={() => {
            onDelete(question._id);
          }}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
}
